// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2JL6H","footer":"ModalInfo_footer__mmxp8"};